/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import '@polymer/polymer/polymer-element.js';

const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `
<dom-module id="cs-shared-styles-common-catalog">
	<template>
		<custom-style>
			<style>
        :host {
            position: relative
        }

        @keyframes infinite-rotate {
            from {
                transform: rotate(0)
            }

            to {
                transform: rotate(360deg)
            }
        }

        :host([processing][processing-layout=overlay]) .cspl-catalog__items {
            opacity: .4
        }

        .cspl-processing-icon {
            align-items: center;
            color: var(--cs-dark-color);
            display: flex;
            height: 0;
            justify-content: center;
            opacity: 0;
            overflow: hidden;
            pointer-events: none;
            transition-duration: .4s;
            transition-property: opacity, padding, transform;
            transition-timing-function: ease
        }

        :host([processing]) .cspl-processing-icon {
            opacity: 1
        }

        :host([processing-layout=overlay]) .cspl-processing-icon {
            background: rgba(0, 0, 0, .4);
            left: 50%;
            padding: 40px;
            position: absolute;
            top: 50%;
            transform: translate3d(-50%, -50%, 0) scale(1.2)
        }

        :host([processing][processing-layout=overlay]) .cspl-processing-icon {
            height: 104px;
            transform: translate3d(-50%, -50%, 0) scale(1)
        }

        :host([processing-layout=inline]) .cspl-processing-icon {
            margin-top: var(--cs-gutter-mobile);
            transform: scale(.8)
        }

        :host([processing][processing-layout=inline]) .cspl-processing-icon {
            padding: 40px;
            transform: scale(1)
        }

        :host([processing-icon-color=light]) .cspl-processing-icon {
            color: var(--cs-light-color)
        }

        .cspl-processing-icon iron-icon {
            animation: infinite-rotate 1.5s linear infinite
        }
        </style>
		</custom-style>
	</template>
</dom-module>`;

document.head.appendChild($_documentContainer.content);